import WithErrorBoundry from "@components/ErrorBoundry/WithErrorBoundry/WithErrorBoundry";
import AddSparePartsModal from "@components/Pages/SpareParts/modals/AddSpareParts/AddSpareParts.modal";
import AddSparePartsTypesModal from "@components/Pages/SpareParts/modals/AddSparePartsTypes/AddSparePartsTypes.modal";
import TimerBlock from "@components/TimerBlock/TimerBlock";
import ConfirmMinersChanges from "@components/global/ConfirmMinersChanges";
import ConfirmMinersOnOff from "@components/global/ConfirmMinersOnOff";
import MinersDeleteErrorModal from "@components/global/MinersDeleteErrorModal";
import AddTabModal from "@components/global/MinersTableTabs/AddTabModal";
import GlobalNotifs from "@components/global/new/GlobalNotifs/GlobalNotifs";
import MinerChangerLog from "@components/global/new/MinerChangerLog/MinerChangerLog";
import ContactsSalesNew from "@components/modals/ContactsSalesNew/ContactsSalesNew";
import AddClient from "@components/modals/newModals/AddClient/AddClient";
import AddLocation from "@components/modals/newModals/AddLocation/AddLocation";
import AddNotifsEmail from "@components/modals/newModals/AddNotifsEmail/AddNotifsEmail";
import AddPoolSetting from "@components/modals/newModals/AddPoolSetting/AddPoolSetting";
import ChangeClientPasswordMoal from "@components/modals/newModals/ChangeClientPasswordMoal/ChangeClientPasswordMoal";
import ConfirmModal from "@components/modals/newModals/ConfirmModal/ConfirmModal";
import CreatePlanModal from "@components/modals/newModals/CrateRateModal/CreatePlanModal";
import CreateContractModal from "@components/modals/newModals/CreateContractModal/CreateContractModal";
import CreateMinerProfile from "@components/modals/newModals/CreateMinerProfile/CreateMinerProfile";
import CreateMinerProfileMobx from "@components/modals/newModals/CreateMinerProfileMobx/CreateMinerProfileMobx";
import CreateSparePartModal from "@components/modals/newModals/CreateSparePartModal/CreateSparePartModal";
import CreatedTwoFA from "@components/modals/newModals/CreatedTwoFA/CreatedTwoFA";
import DeleteMiner from "@components/modals/newModals/DeleteMiner/DeleteMiner";
import EditAccount from "@components/modals/newModals/EditAccount/EditAccount";
import EditClientColor from "@components/modals/newModals/EditClientColor/EditClientColor";
import ErrorModal from "@components/modals/newModals/ErrorModal";
import ForgotModal from "@components/modals/newModals/ForgotModal/ForgotModal";
import LogModal from "@components/modals/newModals/LogModal/LogModal";
import MoreModal from "@components/modals/newModals/MinerInfoModal/MinerInfoModal";
import MoreClientModal from "@components/modals/newModals/MoreClientModal/MoreClientModal";
import MovePartModal from "@components/modals/newModals/MovePartModal/MovePartModal";
import QrModal from "@components/modals/newModals/QrModal/QrModal";
import RackModal from "@components/modals/newModals/RackModal/RackModal";
import ShowProxySetting from "@components/modals/newModals/ShowProxySetting/ShowProxySetting";
import TwoFaModal from "@components/modals/newModals/TwoFaModal/TwoFaModal";
import UploadMinerPhotoModal from "@components/modals/newModals/UploadMinerPhotoModal/UploadMinerPhotoModal";
import { useMe } from "@utils/hooks/useMe";
import useMediaQuery from "@utils/hooks/utils";
import { ReactNode } from "react";
import Subscribe from "../global/Subscribe/Subscribe";
import styles from "./Layout.module.scss";
import ChoiceModal from "@components/modals/newModals/ChoiceModal/ChoiceModal";
import MinerStatusesModal from "@components/modals/newModals/MinerStatusesModel/MinerStatusesModal";
import MinerPortsModal from "@components/Pages/Machines/MinerRow/MinerPorts/MinerPorts.modal";
import EditTemplateModal from "@components/modals/newModals/EditTemplateModal/EditTemplateModal";
import MoveMinersModal from "@components/modals/newModals/MoveMinersModal/MoveMinersModal";
import RackModal3 from "@mobx/components/RackModal3";
import AddBuildingModal3 from "@mobx/components/AddBuildingModal3";
import AddLocationModal3 from "@mobx/components/AddLocationModal3";
import EquipmentModal3 from "@mobx/components/EquipmentModal3";
import EditGeneralNotifications from "@components/modals/newModals/EditGeneralNotifications/EditGeneralNotifications";
import EditNotificationGroup from "@components/modals/newModals/EditNotificationGroup/EditNotificationGroup";
import EditNotificationMiner from "@components/modals/newModals/EditNotificationMiner/EditNotificationMiner";
import AssignNotificationGroup from "@components/modals/newModals/AssignNotificationGroup/AssignNotificationGroup";
import { WLP202603 } from "../../config";

interface LayoutPropsI {
  children: ReactNode;
}

function Layout({ children }: LayoutPropsI) {
  const me = useMe();
  const isSm = useMediaQuery("max", 768);
  const showSubscribe = !me?.email && !(WLP202603 && isSm);

  return (
    <>
      {showSubscribe && <Subscribe />}

      {/* Нотификации у мышки */}
      <GlobalNotifs />

      {/* //modals */}
      <ForgotModal />
      <EditAccount />
      <DeleteMiner />
      <AddClient />
      <AddPoolSetting />
      <ShowProxySetting />
      <ContactsSalesNew />
      <MoreModal />
      <MoreClientModal />
      <CreatePlanModal />
      <QrModal />
      <AddNotifsEmail />
      <CreatedTwoFA />
      <TwoFaModal />
      <AddLocation />
      <AddLocationModal3 />
      <LogModal />
      <EditClientColor />
      <RackModal />
      <RackModal3 />
      <EquipmentModal3 />
      <AddBuildingModal3 />
      <AddTabModal />
      <UploadMinerPhotoModal />
      <ConfirmMinersChanges />
      <ConfirmMinersOnOff />
      <ChangeClientPasswordMoal />
      <ConfirmModal />
      <ErrorModal />
      <CreateContractModal />
      <MinersDeleteErrorModal />
      <CreateMinerProfile />
      <CreateMinerProfileMobx />
      <AddSparePartsModal />
      <AddSparePartsTypesModal />
      <MovePartModal />
      <CreateSparePartModal />
      <TimerBlock />
      <ChoiceModal />
      <MinerStatusesModal />
      <MinerPortsModal />
      <EditTemplateModal />
      <MoveMinersModal />
      <EditGeneralNotifications />
      <EditNotificationGroup />
      <EditNotificationMiner />
      <AssignNotificationGroup />

      {/* <Header /> */}
      <main className={styles.content_wrapper}>{children}</main>
      {/* Miner log */}
      <MinerChangerLog />
      {/* <Footer /> */}
    </>
  );
}

export default WithErrorBoundry(Layout);
